/**
 * Application entry point.
 * Mounts <App /> into #root and loads the global icon-font / responsive CSS
 * that the legacy template depends on. Vite serves this file from index.html.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './main-component/App/App';
import './css/font-awesome.min.css';
import './css/themify-icons.css';
import './css/flaticon.css';
import './css/responsive.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
